var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "products-section" }, [
    _vm.segments.length > 0 ||
    _vm.productTypes.length > 0 ||
    _vm.markets.length > 0
      ? _c("div", { staticClass: "filter-section" }, [
          _c("div", { staticClass: "filter-items" }, [
            _vm.segments.length > 0 && !_vm.hideSegments
              ? _c("div", { staticClass: "filter-item filter-item--mw" }, [
                  _c(
                    "label",
                    {
                      staticClass: "sr-only",
                      attrs: { for: "segmentsFilter" }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.dictionaries.ProductSegmentOptionDefault)
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.segment,
                          expression: "segment"
                        }
                      ],
                      staticClass: "filter-item__select",
                      attrs: {
                        id: "segmentsFilter",
                        name: "segmentsFilter",
                        disabled: _vm.isLoading
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.segment = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.filterChanged
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { value: "All" } }, [
                        _vm._v(
                          _vm._s(_vm.dictionaries.ProductSegmentOptionDefault)
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.segments, function(segment, index) {
                        return segment.Name
                          ? _c("option", { domProps: { value: segment.Key } }, [
                              _vm._v(_vm._s(segment.Name))
                            ])
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.productTypes.length > 0
              ? _c("div", { staticClass: "filter-item filter-item--mw" }, [
                  _c(
                    "label",
                    {
                      staticClass: "sr-only",
                      attrs: { for: "productTypeFilter" }
                    },
                    [_vm._v(_vm._s(_vm.dictionaries.ProductTypeOptionDefault))]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.productType,
                          expression: "productType"
                        }
                      ],
                      staticClass: "filter-item__select",
                      attrs: {
                        id: "productTypeFilter",
                        name: "productTypeFilter",
                        disabled: _vm.isLoading
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.productType = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.filterChanged
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { value: "All" } }, [
                        _vm._v(
                          _vm._s(_vm.dictionaries.ProductTypeOptionDefault)
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.productTypes, function(productType, index) {
                        return productType.Name
                          ? _c(
                              "option",
                              { domProps: { value: productType.Key } },
                              [_vm._v(_vm._s(productType.Name))]
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.markets.length > 0
              ? _c("div", { staticClass: "filter-item filter-item--mw" }, [
                  _c(
                    "label",
                    { staticClass: "sr-only", attrs: { for: "marketFilter" } },
                    [
                      _vm._v(
                        _vm._s(_vm.dictionaries.ProductMarketOptionDefault)
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.market,
                          expression: "market"
                        }
                      ],
                      staticClass: "filter-item__select",
                      attrs: {
                        id: "marketFilter",
                        name: "marketFilter",
                        disabled: _vm.isLoading
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.market = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.filterChanged
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { value: "All" } }, [
                        _vm._v(
                          _vm._s(_vm.dictionaries.ProductMarketOptionDefault)
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.markets, function(market, index) {
                        return market.Name
                          ? _c("option", { domProps: { value: market.Key } }, [
                              _vm._v(_vm._s(market.Name))
                            ])
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "filter-item" }, [
              _c(
                "button",
                {
                  staticClass: "filter-item__button",
                  attrs: { type: "button", disabled: _vm.isLoading },
                  on: { click: _vm.resetFilter }
                },
                [_vm._v(_vm._s(_vm.dictionaries.ProductFilterReset))]
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.products.length,
            expression: "products.length"
          }
        ],
        staticClass: "products-items"
      },
      _vm._l(_vm.products, function(productItem) {
        return _c("productItem", {
          key: productItem.Id,
          attrs: { productItem: productItem }
        })
      }),
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.products.length && !_vm.isLoading,
            expression: "!products.length && !isLoading"
          }
        ],
        staticClass: "products-items__no-result"
      },
      [_vm._v(_vm._s(_vm.dictionaries.ProductNoResult))]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.hasMoreProductsToLoad,
            expression: "hasMoreProductsToLoad"
          }
        ],
        staticClass: "products-items__cta"
      },
      [
        _c(
          "a",
          {
            staticClass: "products-items__load-more",
            attrs: { disabled: _vm.isLoading },
            on: { click: _vm.getNextPage }
          },
          [_vm._v(_vm._s(_vm.dictionaries.ProductLoadMore))]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d33ced4", { render: render, staticRenderFns: staticRenderFns })
  }
}